export default __webpack_public_path__ + "static/media/info-tooltip.59fbda98.svg";